import { errorIcon, greenVIcon } from '@/assets/images/icons';
import { Accordion } from '@/shared/components/Accordion/Accordion';
import { Icon } from '@/shared/components/Icon';
import { StyledCard, StyledText, StyledTitle } from '@/shared/styles';
import { useAccessibilityCheckerStore } from '@/stores/AccessibilityCheckerStore/AccessibilityCheckerStore';
import { A11yIssuesAccordionStyle, StyledIssuesTitleRow } from '../AccessibilityIssues.styles';
import { isMobileOnly } from 'react-device-detect';
import { StyledScoreSeparator } from '../../AccessibilityScore/AccessibilityScore.styles';
import { PinkGradientLink } from '@/shared/components/Link/PinkGradientLink';
import { useTranslation } from 'react-i18next';
import { downloadPdf } from '../AccessibilityIssues.utils';
import { getAccordionRows } from './FilteredIssues.consts';
import { StyledAuditText } from './FilteredIssues.styles';
import { useLangStore } from '@/stores/LangStore/LangStore';
import { useEffect, useState } from 'react';

export const FilteredIssues: React.FC = () => {
  const { t } = useTranslation();
  const accessibilityCheckerStore = useAccessibilityCheckerStore();
  const { selectedIssueCategory, filteredIssues, getAmountOfIssuePerCategory } =
    accessibilityCheckerStore;
  const isRtl = useLangStore((state) => state.isRtl);
  const [hasIssues, setHasIssues] = useState(false);

  useEffect(() => {
    setHasIssues(getAmountOfIssuePerCategory(selectedIssueCategory) > 0);
  }, [selectedIssueCategory]);

  return (
    <StyledCard
      $width="100%"
      $height={filteredIssues.length ? 'auto' : 'fit-content'}
      $padding={40}
      $align="start"
      $gap={20}
    >
      <StyledIssuesTitleRow>
        <StyledTitle level={3} $size={24}>
          {t(`free_tools.accessibility_checker.category.${selectedIssueCategory}`)}
        </StyledTitle>
        {isMobileOnly && <StyledScoreSeparator />}
        <StyledAuditText $isRtl={isRtl()}>
          <Icon $src={hasIssues ? errorIcon : greenVIcon} />
          <StyledText fontSize="20px" fontWeight={600} $noBreak={true}>
            {hasIssues
              ? t('free_tools.accessibility_checker.audit_failed')
              : t('free_tools.accessibility_checker.audit_passed')}
          </StyledText>
        </StyledAuditText>
      </StyledIssuesTitleRow>
      {filteredIssues.length > 0 && (
        <Accordion
          $accrodionRows={getAccordionRows(filteredIssues)}
          $customStyle={A11yIssuesAccordionStyle}
          $largeContent={true}
        />
      )}
      {isMobileOnly && (
        <PinkGradientLink
          isButton={true}
          text={t('free_tools.download_pdf')}
          onClick={() => downloadPdf(accessibilityCheckerStore)}
        />
      )}
    </StyledCard>
  );
};
